<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Add a Allocation Rules
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >Add
          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider class="mb-2"></v-divider>
      <v-card-text dense>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" md="3" class="pb-0">
              <v-autocomplete
                v-model="selectedClientId"
                :items="clients"
                :loading="clientLoader"
                item-text="name"
                item-value="id"
                label="Select Client"
                placeholder="Start typing to Search"
                class="required pb-0"
                :rules="[(v) => !!v || 'Please Select Client']"
                outlined
                @change="clearAll()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" v-if="validation.length > 0" class="pb-0">
              <div
                v-for="(valid, index) in validation"
                :key="index"
                class="pb-0"
              >
                <b>{{ valid.key }}</b> : {{ valid.value }}
                <span v-if="valid.limit"><b>Limit</b>: {{ valid.limit }}</span>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="3" md="3" class="pb-0" v-if="selectedClientId">
              <v-autocomplete
                label="Payment Mode"
                :items="paymentModes"
                v-model="service_payment_type"
                :rules="[(v) => !!v || 'Payment Mode is required.']"
                class="required pb-0"
                item-value="value"
                outlined
                placeholder="Start typing to Search"
                @input="clearCitySection()"
                item-text="text"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="pb-0" v-if="selectedClientId">
              <v-autocomplete
                v-model="delivery_type"
                :items="deliveryTypes"
                item-text="text"
                item-value="value"
                label="Delivery Type"
                class="required pb-0"
                :rules="[(v) => !!v || 'Please Select Delivery Type']"
                outlined
                @input="getConfigType()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="pb-0" v-if="selectedClientId">
              <v-autocomplete
                v-model="sericesType"
                :items="sericesTypes"
                :item-text="
                  (item) => `${item.service_name} - (${item.service_code})`
                "
                item-value="service_code"
                label="Service Type"
                class="required pb-0"
                :rules="[(v) => !!v || 'Please Select Service Type']"
                outlined
                @input="clearCitySection()"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="duty_handling && delivery_type == 'crossborder'"
              class="pb-0"
            >
              <v-autocomplete
                v-if="
                  duty_handling_value == 'ddu,ddp' ||
                  duty_handling_value == 'ddp,ddu'
                "
                v-model="duty_handling_value_selected"
                :items="dutyhandlings"
                :loading="countryLoader"
                item-text="text"
                item-value="value"
                label="Select Duty Handling Type"
                placeholder="Start typing to Search"
                class="required pb-0"
                :rules="[(v) => !!v || 'Please Select Duty Handling']"
                outlined
                @input="clearCitySection()"
              ></v-autocomplete>

              <v-text-field
                v-else
                :value="
                  duty_handling_value_new
                    ? duty_handling_value_new.toUpperCase()
                    : ''
                "
                outlined
                hide-details
                class="pt-0"
                label="Duty Handling"
                disabled
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="delivery_type == 'crossborder' && duty_handling == false"
              class="pb-0"
            >
              <v-autocomplete
                v-model="duty_handling_value_selected"
                :items="dutyhandlingsNull"
                :loading="countryLoader"
                item-text="text"
                item-value="value"
                label="Select Duty Handling Type"
                placeholder="Start typing to Search"
                class="required pb-0"
                :rules="[(v) => !!v || 'Please Select Duty Handling']"
                outlined
                @input="clearCitySection()"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="pl-0 pb-0" v-if="delivery_type && service_payment_type">
            <v-col cols="12" md="4" class="d-flex pb-0">
              <v-autocomplete
                v-model="selectedFromCountry"
                :items="fromCountries"
                :loading="countryLoader"
                item-text="name"
                item-value="id"
                label="From Country"
                placeholder="Start typing to Search"
                class="required pb-0"
                :rules="[(v) => !!v || 'Please Select From Country']"
                outlined
                @input="changeFLag(selectedFromCountry)"
              ></v-autocomplete>
              <img :src="fromFLag" class="ma-3 logo" />
            </v-col>
            <v-col cols="12" md="4" class="d-flex pb-0">
              <v-autocomplete
                v-model="selectedToCountry"
                :loading="countryLoader"
                :items="toCountries"
                item-text="name"
                item-value="id"
                label="To Country"
                placeholder="Start typing to Search"
                class="required pb-0"
                @input="changeToFLag(selectedToCountry)"
                :rules="[(v) => !!v || 'Please Select To Country']"
                outlined
              ></v-autocomplete>
              <img :src="to" class="ma-3 logo" />
            </v-col>
          </v-row>
          <v-divider class="my-4" v-if="selectedToCountry"></v-divider>
          <img
            v-if="selectedToCountry"
            src="/images/type_icon/linehaul_type_last_mile_agent.png"
            class="carrier-logo mb-2"
          />
          <v-row class="mb-5 pl-1">
            <v-col
              cols="12"
              md="4"
              class="d-flex"
              v-if="delivery_type && selectedToCountry && selectedFromCountry"
            >
              <b class="pr-4 pt-2">City :</b>

              <v-btn color="info" @click="cityDownload">Download</v-btn>
              <v-btn color="primary" class="ml-4" @click="uploadForm = true"
                >Upload</v-btn
              >
              <v-icon
                small
                class="ml-2"
                @click="cityListPopup = true"
                v-bind="attrs"
                v-on="on"
                v-if="city_list.length > 0"
              >
                mdi-city
              </v-icon>
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="d-flex"
              v-if="is_area_required == true && this.areaShow == true"
            >
              <b class="pr-4 pt-2">Area :</b>

              <v-btn color="info" @click="areaDownload">Download</v-btn>
              <v-btn color="primary" class="ml-4" @click="uploadAreaForm = true"
                >Upload</v-btn
              >
              <v-icon
                small
                class="ml-2"
                @click="areaListPopup = true"
                v-bind="attrs"
                v-on="on"
                v-if="area_list.length"
              >
                mdi-download
              </v-icon>
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="d-flex"
              v-if="is_pincode_required == true"
            >
              <b class="pr-4 pt-2 mb-4">Pincode :</b>

              <v-btn color="info" @click="pinDownload">Download</v-btn>
              <v-btn color="primary" class="ml-4" @click="uploadPinForm = true"
                >Upload</v-btn
              >

              <v-icon
                small
                class="ml-2"
                @click="pinListPopup = true"
                v-bind="attrs"
                v-on="on"
                v-if="pincode_list.length"
              >
                mdi-map-marker
              </v-icon>
            </v-col>
          </v-row>
          <v-row class="pl-4">
            <v-col
              cols="12"
              md="4"
              class="d-flex pl-0"
              v-if="selectedToCountry"
            >
              <v-select
                v-model="selectedCarrier"
                :items="carrier_list"
                item-text="name"
                item-value="id"
                outlined
                multiple
                class="required pb-0"
                label="Select Carrier"
                :rules="[(v) => v.length > 0 || 'Carrier is required.']"
              ></v-select>
            </v-col>
            <v-col cols="12" md="3" v-if="carrier_list.length > 0" class="pb-0">
              <div
                v-for="(valid, index) in carrier_list"
                :key="index"
                class="pb-0"
              >
                <b v-if="valid.weight">{{ valid.name }}</b>
                <span v-if="valid.weight">: Max - {{ valid.weight }} Kg </span>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-btn
              color="primary"
              @click="saveData"
              class="ml-4 mb-10"
              v-if="checkPermission('app_linehaul:linehaul_update')"
              >Save</v-btn
            >

            <v-btn
              color="white"
              @click="$router.push('/rulesAllocation')"
              class="ml-4 mb-10"
              >Close</v-btn
            >
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="uploadForm"
      max-width="750px"
      close-delay="ma-5"
      @keydown.esc="uploadForm = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Upload City</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>

        <v-card-text>
          <v-form ref="formCity" lazy-validation>
            <v-row>
              <v-col>
                <v-file-input
                  v-model="file"
                  accept=".xlsx"
                  label="Select your Excel file"
                  class="required"
                  outlined
                  :rules="[(v) => !!v || 'Please select File']"
                >
                </v-file-input>

                <v-btn
                  color="primary"
                  dark
                  class="mt-3"
                  :loading="fileLoader"
                  @click="uploadcity"
                >
                  Upload
                </v-btn>

                <v-btn
                  class="mt-3 ml-3"
                  @click="
                    uploadForm = false;
                    $refs.formcity.reset();
                  "
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="uploadAreaForm"
      max-width="750px"
      close-delay="ma-5"
      @keydown.esc="uploadAreaForm = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Upload Area</span>

          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>

        <v-card-text>
          <v-form ref="formarea" lazy-validation>
            <v-row>
              <v-col>
                <v-file-input
                  v-model="fileArea"
                  show-size
                  accept=".xlsx"
                  label="Select your Excel file"
                  class="required"
                  outlined
                  :rules="[(v) => !!v || 'Please select Excel File']"
                >
                </v-file-input>
                <v-btn
                  color="primary"
                  dark
                  class="mt-3"
                  :loading="fileLoader"
                  @click="uploadArea"
                >
                  Upload
                </v-btn>

                <v-btn
                  class="mt-3 ml-3"
                  @click="
                    uploadAreaForm = false;
                    $refs.formarea.reset();
                  "
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="uploadPinForm"
      max-width="750px"
      close-delay="ma-5"
      @keydown.esc="uploadPinForm = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Upload Pincode</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>

        <v-card-text>
          <v-form ref="formpin" lazy-validation>
            <v-row>
              <v-col>
                <v-file-input
                  v-model="filePin"
                  show-size
                  accept=".xlsx"
                  label="Select your Excel file"
                  class="required"
                  outlined
                  :rules="[(v) => !!v || 'Please select Excel File']"
                >
                </v-file-input>
                <v-btn
                  color="primary"
                  dark
                  class="mt-3"
                  :loading="fileLoader"
                  @click="uploadPin(filePin)"
                >
                  Upload
                </v-btn>

                <v-btn
                  class="mt-3 ml-3"
                  @click="
                    uploadPinForm = false;
                    $refs.formpin.reset();
                  "
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="cityListPopup"
      max-width="500px"
      close-delay="ma-5"
      @keydown.esc="cityListPopup = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Uploaded Cities</span>
          <v-spacer></v-spacer>
          <v-icon @click="cityListPopup = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-0">
          <div class="pl-4 pt-4">
            <ul>
              <li v-for="city in city_list" :key="city">
                {{ city }}
              </li>
            </ul>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="areaListPopup"
      max-width="500px"
      close-delay="ma-5"
      @keydown.esc="areaListPopup = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Uploaded Area</span>
          <v-spacer></v-spacer>
          <v-icon @click="areaListPopup = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-0">
          <div class="pl-4 pt-4">
            <ul>
              <li v-for="area in area_list" :key="area">
                {{ area }}
              </li>
            </ul>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="pinListPopup"
      max-width="500px"
      close-delay="ma-5"
      @keydown.esc="pinListPopup = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Uploaded Pincode</span>
          <v-spacer></v-spacer>
          <v-icon @click="pinListPopup = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-0">
          <div class="pl-4 pt-4">
            <ul>
              <li v-for="pin in pincode_list" :key="pin">
                {{ pin }}
              </li>
            </ul>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  async created() {
    if (this.$route.params.id == 0) await this.fetchClientList();
    if (this.$route.params.id > 0) await this.getData();
  },
  async mounted() {},
  watch: {
    selectedClientId() {
      // if (this.selectedClientId && this.$route.params.id == 0) {
      //   this.getConfig();
      // }
    },
  },
  computed: {},
  data() {
    return {
      area_list: [],
      fileLoader: false,
      filePin: null,
      countryFlag: null,
      carrier_list: [],
      pincode_list: [],
      cityListPopup: false,
      areaListPopup: false,
      pinListPopup: false,
      uploadPinForm: false,
      service_payment_type: null,
      uploadForm: false,
      uploadAreaForm: false,
      sericesTypes: [],
      sericesType: "",
      deliveryTypes: [
        { text: "Cross Border", value: "crossborder" },
        { text: "Domestic", value: "domestic" },
      ],
      clientLoader: false,
      clients: [],
      selectedClientId: null,
      fromCountries: [],
      toCountries: [],
      selectedFromCountry: null,
      selectedToCountry: null,
      selectedTransitCountry: null,
      fromFLag: "",
      to: "",
      transitFlag: "",
      originAgent: [],
      transitPartner: [],
      origin_agent: null,
      transit_partner: null,
      objArr: {},
      selectedCarrier: [],
      transitCountry: "",
      carrier_logo: {},
      countryLoader: false,
      transitLoader: false,
      validation: [],
      duty_handling_value: null,
      duty_handling: false,
      duty_handling_value_new: null,
      duty_handling_value_selected: null,
      selectedDutyHandling: null,
      dutyhandlings: [
        { text: "DDU", value: "ddu" },
        { text: "DDP", value: "ddp" },
      ],
      dutyhandlingsNull: [],
      delivery_type: null,
      linehaul_id: null,
      file: null,
      is_area_required: false,
      city_list: [],
      fileArea: null,
      areaShow: false,
      is_pincode_required: false,
      paymentModes: [
        {
          text: "COD",
          value: "COD",
        },
        {
          text: "Prepaid",
          value: "Prepaid",
        },
        {
          text: "COD & Prepaid",
          value: "COD,Prepaid",
        },
      ],
    };
  },
  methods: {
    ...mapActions([
      "fetchClient",
      "snackBar",
      "getLinehaulConfiguration",
      "getTransitCountry",
      "addLInehaul",
      "getLinehaulDelivery",
      "linehaulCityDownload",
    ]),
    clearCitySection() {
      this.selectedToCountry = null;
      this.selectedFromCountry = null;
      this.is_pincode_required = false;
      this.to = null;
      this.fromFLag = null;
    },
    pinDownload() {
      let payload = {
        destination_country: this.selectedToCountry,
        type: "pincode",
      };
      if (this.pincode_list.length > 0) {
        payload.lastmile_pincode_list = this.pincode_list;
      }
      this.linehaulCityDownload(payload)
        .then((res) => {
          this.fileDownload(res);
        })
        .catch(() => {});
    },
    areaDownload() {
      let payload = {
        destination_country: this.selectedToCountry,
        type: "area",
        city_list: this.city_list,
        service_payment_type: this.service_payment_type,
        duty_handling: this.duty_handling_value_new,
        delivery_type: this.delivery_type,
      };
      if (this.area_list.length > 0) {
        payload.lastmile_area_list = this.area_list;
      }
      this.linehaulCityDownload(payload)
        .then((res) => {
          this.fileDownload(res);
        })
        .catch(() => {});
    },
    cityDownload() {
      let payload = {
        destination_country: this.selectedToCountry,
        type: "city",
        service_payment_type: this.service_payment_type,
        duty_handling: this.duty_handling_value_new,
        delivery_type: this.delivery_type,
      };
      if (this.city_list.length > 0) {
        payload.lastmile_city_list = this.city_list;
      }
      this.linehaulCityDownload(payload)
        .then((res) => {
          this.fileDownload(res);
        })
        .catch(() => {});
    },
    uploadcity() {
      if (!this.$refs.formCity.validate()) {
        return;
      }
      this.callApi("city", this.file);
    },
    uploadArea() {
      if (!this.$refs.formarea.validate()) {
        return;
      }
      this.callApi("area", this.fileArea);
    },
    uploadPin(file) {
      if (!this.$refs.formpin.validate()) {
        return;
      }
      const payload = new FormData();
      payload.append("destination_country", this.selectedToCountry);
      payload.append("client_id", this.selectedClientId);
      payload.append("origin_country", this.selectedFromCountry);
      payload.append("duty_handling", this.duty_handling_value_new);
      payload.append("delivery_type", this.delivery_type);
      payload.append("type", "pincode");
      payload.append("service_payment_type", this.service_payment_type);
      payload.append("service_type", this.sericesType);

      if (file) {
        payload.append("data_file", file);
      }
      if (this.selectedClientId !== undefined) {
        this.getTransitCountry(payload)
          .then((response) => {
            this.pincode_list = response.data.pincode;
            this.uploadPinForm = false;

            if (file) {
              this.snackBar({
                color: "success",
                message: "Uploaded Successfully",
              });
            }
          })
          .catch(() => {
            this.transitLoader = false;
            this.filePin = null;
          });
      }
    },
    async getData() {
      if (this.$route.params.client_id > 0) {
        this.duty_handling_value_selected = this.$route.params.duty_handling;
        this.delivery_type = this.$route.params.delivery_type;
        this.linehaul_id = this.$route.params.id;
      }
    },

    fetchClientList() {
      if (this.clients.length) return;
      this.clientLoader = true;
      this.getData();
      this.fetchClient({
        service: "clickdna,fulfillment_wid_last_mile",
      })
        .then((res) => {
          this.clientLoader = false;
          this.clients = res.data;
        })
        .catch(() => {
          this.clientLoader = false;
        });
    },
    async getConfig() {
      this.countryLoader = true;

      await this.getLinehaulConfiguration(this.selectedClientId)
        .then((response) => {
          this.fromCountries = response.data.from_countries;
          this.toCountries = response.data.to_countries;
          this.validation = response.data.validation;

          this.validation.forEach((e) => {
            if (e.key == "duty_handling") {
              this.duty_handling = true;
              this.duty_handling_value = e.value;
              this.duty_handling_value_new = e.value;
            }
          });
          this.countryLoader = false;
        })
        .catch(() => {
          this.countryLoader = false;
        });
    },
    async getConfigType() {
      this.to = null;
      this.fromFLag = null;
      this.fromCountries = [];
      this.toCountries = [];
      this.selectedFromCountry = null;
      this.selectedToCountry = null;
      this.sericesType = null;

      if (this.selectedClientId !== null && this.delivery_type !== null) {
        this.countryLoader = true;
        let data = { id: this.selectedClientId, type: this.delivery_type };
        await this.getLinehaulDelivery(data)
          .then((response) => {
            this.fromCountries = response.data.from_countries;
            this.toCountries = response.data.to_countries;
            this.validation = response.data.validation;
            this.sericesTypes = response.data.service_types;

            this.validation.forEach((e) => {
              if (e.key == "duty_handling") {
                this.duty_handling = true;
                this.duty_handling_value = e.value;
                this.duty_handling_value_new = e.value;
              }
            });
            this.countryLoader = false;
          })
          .catch(() => {
            this.countryLoader = false;
            this.city_list = [];
            this.area_list = [];
            this.is_area_required = false;
            this.is_pincode_required = false;

            this.uploadForm = false;
            this.uploadAreaForm = false;
            this.carrier_list = [];
            this.countryFlag = null;
            this.fromCountries = [];
            this.toCountries = [];
            this.validation = [];
          });
      }
    },
    async changeFLag(item) {
      await this.fromCountries.forEach((e) => {
        if (e.id == item) {
          return (this.fromFLag =
            "/images/flags/" + e.flag_url.split("/").pop());
        }
      });
      this.callApi("country");
    },
    changeToFLag(item) {
      this.selectedCarrier = [];
      this.carrier_list = [];
      this.toCountries.map((e) => {
        if (e.id == item) {
          return (this.to = "/images/flags/" + e.flag_url.split("/").pop());
        }
      });
      this.callApi("country");
    },

    async callApi(from, file) {
      this.carrier_list = [];
      if (
        this.selectedFromCountry !== null &&
        this.selectedToCountry !== null &&
        this.selectedFromCountry !== undefined &&
        this.selectedToCountry !== undefined
      ) {
        if (this.duty_handling_value_selected) {
          this.duty_handling_value_new = this.duty_handling_value_selected;
        }
        if (this.delivery_type == "domestic") {
          this.duty_handling_value_new = "";
        }
        if (from == "payment") {
          if (this.selectedToCountry || this.selectedFromCountry) {
            from = "country";
          }
          if (this.city_list.length > 0) {
            from = "city";
          }
          if (this.area_list.length > 0) {
            from = "area";
          }
        }
        if (this.sericesType == null) {
          this.snackBar({
            color: "warning",
            message: "Service Type is required",
          });
        }
        const payload = new FormData();
        payload.append("destination_country", this.selectedToCountry);
        payload.append("client_id", this.selectedClientId);
        payload.append("origin_country", this.selectedFromCountry);
        payload.append("duty_handling", this.duty_handling_value_new);
        payload.append("delivery_type", this.delivery_type);
        payload.append("type", from);
        payload.append("service_payment_type", this.service_payment_type);
        payload.append("service_type", this.sericesType);

        if (file) {
          payload.append("data_file", file);
        }

        if (this.selectedClientId !== undefined) {
          await this.getTransitCountry(payload)
            .then((response) => {
              this.city_list = response.data.lastmile_city_list;
              this.area_list = response.data.lastmile_area_list;
              this.is_area_required = response.data.lastmile_is_area_required;
              this.is_pincode_required =
                response.data.lastmile_is_pincode_required;

              this.uploadForm = false;
              this.uploadAreaForm = false;
              this.carrier_list = response.data.lastmile_carrier_list;
              this.countryFlag =
                "/images/flags/" +
                response.data.lastmile_country_flag.split("/").pop();
              if (file) {
                this.snackBar({
                  color: "success",
                  message: "Uploaded Successfully",
                });
              }
              if (from == "city") {
                this.areaShow = true;
              }
              if (from == "area") {
                this.pincodeshow = true;
              }
            })
            .catch(() => {
              this.transitLoader = false;
              this.countryFlag = null;
              this.file = null;
              this.fileArea = null;
              this.carrier_list = [];
            });
        }
      }
    },
    clearAll() {
      this.selectedToCountry = null;
      this.selectedFromCountry = null;
      this.duty_handling_value_new = null;
      this.duty_handling = false;
      this.delivery_type = null;
      this.service_payment_type = null;
      this.sericesType = null;
      this.objArr = {};
    },
    image(data) {
      return "/images/flags/" + data.country_flag.split("/").pop();
    },
    label(data) {
      if (data.label_icon)
        return "/images/type_icon/" + data.label_icon.split("/").pop();
    },

    saveData() {
      if (!this.$refs.form.validate()) return;
      if (this.duty_handling_value_new == "ddu,ddp") {
        this.duty_handling_value_new = this.duty_handling_value_selected;
      }
      if (this.delivery_type == "domestic") {
        this.duty_handling_value_new = "";
      }

      let obj = {
        client_id: this.selectedClientId,
        origin_country: this.selectedFromCountry,
        destination_country: this.selectedToCountry,
        transit_country: this.transit_country_id,
        transit_city: this.transit_country_city_id,
        duty_handling: this.duty_handling_value_new,
        delivery_type: this.delivery_type,
        linehaul_id: this.linehaul_id,
        service_payment_type: this.service_payment_type,
        lastmile_carrier_list: this.selectedCarrier,
        lastmile_city_list: this.city_list,
        lastmile_area_list: this.area_list,
        lastmile_pincode_list: this.pincode_list,
        service_type: this.sericesType,
      };

      this.addLInehaul(obj).then((result) => {
        this.snackBar({
          color: "success",
          message: result.data.message,
        });
        this.$router.push({
          name: "Linehaul",
        });
      });
    },
  },
};
</script>
<style>
.logo {
  max-width: 100px;
  max-height: 20px;
}
.carrier-logo {
  width: 81px;
  height: 52px;
}
</style>
